(() => {
  const selector = {
    slider: '.js-featured-reviews-ds',
  };

  const slider = document.querySelector(selector.slider);

  const slickSettings = {
    infinite: false,
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    autoplay: slider.dataset.autoPlay === "true" ? true : false,
    autoplaySpeed: +slider.dataset.playSpeed,
    speed: 3000,
    adaptiveHeight: true
  };

  $(slider).slick(slickSettings);
})();
